const LayoutElements = () => {
  return null;
};

export default LayoutElements;
